import { render } from "./StatsBuilderRow.vue?vue&type=template&id=49e752f2&scoped=true"
import script from "./StatsBuilderRow.vue?vue&type=script&lang=ts"
export * from "./StatsBuilderRow.vue?vue&type=script&lang=ts"

import "./StatsBuilderRow.vue?vue&type=style&index=0&id=49e752f2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-49e752f2"

export default script